export const selectAuthState = (state) => state?.auth;

// The persisted auth shape in this app is historically inconsistent:
// - sometimes `state.auth.user` is the persisted object
// - sometimes the actual user payload is under `state.auth.user.user`
export const selectAuthPersisted = (state) => selectAuthState(state)?.user;

export const selectCurrentUser = (state) =>
  selectAuthPersisted(state)?.user || selectAuthPersisted(state) || null;

export const selectCurrentUserId = (state) => selectCurrentUser(state)?._id || null;

